import { Injectable, Inject} from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IActivityLog } from '../Models/IActivityLog';

@Injectable()
export class ActivityLogService extends BaseService {
  _baseUrl: string = "";
  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getAllActivityLogForStudent(activityLogCriteria: string): Observable<IActivityLog[]> {
    return this._http.get<IActivityLog[]>(this._baseUrl + "api/ActivityLog/GetAllActivityLogForStudent" + activityLogCriteria)
      .map((response: IActivityLog[]) => response as IActivityLog[])
      .catch(this.errorHandler);
  }

  getActivityLog(id: string): Observable<IActivityLog> {
    return this._http.get<IActivityLog>(this._baseUrl + "api/ActivityLog/GetActivityLog" + id)
      .map((response: IActivityLog) => response as IActivityLog)
      .catch(this.errorHandler);
  }

  insertUpdateActivityLog(activityLogDetails: IActivityLog): Observable<IActivityLog> {
    return this._http.post<IActivityLog>(this._baseUrl + 'api/ActivityLog/InsertUpdate', activityLogDetails)
      .map((response: IActivityLog) => response as IActivityLog)
      .catch(this.errorHandler);
  }

  errorHandler(error: Response): Observable<any> {
    console.log(error);
    return Observable.throw(error);
  }

}
